// extracted by mini-css-extract-plugin
export var component = "layout-module--component--RmIZE";
export var componentWidthFull = "layout-module--component-width-full--AN2IM";
export var componentWidthNarrow = "layout-module--component-width-narrow---eqlz";